import React, { useEffect, useLayoutEffect, useState } from "react";
import WebsiteHeader from "./header";
import WebsiteFooter from "./footer";
import { Outlet, useLocation } from "react-router-dom";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { useDispatch } from "react-redux";
function WebsiteLayout() {


  const dispatch = useDispatch();
  const location = useLocation();
  const [layoutHeight, setLayoutHeight] = useState("100vh");

  useEffect(() => {
    const body = document.querySelector('body');
    if (body) {
      body.classList.add('restaurant_inner_body');
    }
  }, []);

  useLayoutEffect(() => {
    Promise.all([
      import("../../../assets/website/css/style.css"),
      import("../../../assets/restaurant/css/style.css"),
    ]).then(() => {
      dispatch(setGlobalLoader(false));
    });
  }, []);

  useEffect(() => {
    setLayoutHeight(`${window.innerHeight}px`);
  }, [location]);



  return (
    <div>
      <WebsiteHeader />
      <div className="inner-wraper">
        <Outlet />
      </div>
      <WebsiteFooter />
    </div>
  );
}

export default WebsiteLayout;
